import { useEffect, useState } from "react";
import { getDeliveryHints } from "../services/orderPortal";
import { getCustomerSession } from "../utils/customerSession";

const empty = { names: [], phones: [], addresses: [], pincodes: [] };

/**
 * Load past delivery values for logged-in user (last 100 order rows).
 * Auto-fills fields only when empty and exactly one past value exists.
 */
export function useDeliveryHints(cartLength, setCustomer) {
  const [hints, setHints] = useState(empty);

  useEffect(() => {
    const sess = getCustomerSession();
    if (!sess?.token || !sess.email || cartLength === 0) {
      setHints(empty);
      return;
    }

    let cancelled = false;
    (async () => {
      const res = await getDeliveryHints(sess.email, sess.token);
      if (cancelled) return;
      if (!res.ok || !res.data) {
        setHints(empty);
        return;
      }
      const h = {
        names: Array.isArray(res.data.names) ? res.data.names : [],
        phones: Array.isArray(res.data.phones) ? res.data.phones : [],
        addresses: Array.isArray(res.data.addresses) ? res.data.addresses : [],
        pincodes: Array.isArray(res.data.pincodes) ? res.data.pincodes : [],
      };
      setHints(h);

      setCustomer((prev) => {
        const emailNorm = prev.email.trim().toLowerCase();
        if (emailNorm && emailNorm !== sess.email.toLowerCase()) return prev;
        const next = { ...prev };
        if (!prev.email.trim()) next.email = sess.email;
        if (!prev.name.trim() && h.names.length === 1) next.name = h.names[0];
        if (!prev.phone.trim() && h.phones.length === 1) next.phone = h.phones[0];
        if (!prev.address.trim() && h.addresses.length === 1) next.address = h.addresses[0];
        if (!prev.pincode.trim() && h.pincodes.length === 1) next.pincode = h.pincodes[0];
        return next;
      });
    })();

    return () => {
      cancelled = true;
    };
  }, [cartLength, setCustomer]);

  const session = getCustomerSession();
  const hasSuggestions =
    session &&
    (hints.names.length > 1 ||
      hints.phones.length > 1 ||
      hints.addresses.length > 1 ||
      hints.pincodes.length > 1);

  return { hints, hasSuggestions, sessionEmail: session?.email || null };
}
